import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Page } from "@models/page";
import { EventInfoResponseBody } from "@services/types/events-management-response.type";
import { EventTableRowComponent } from "@shared/components/event-table-row/event-table-row.component";
import { PaginatorModule, PaginatorState } from "primeng/paginator";
import { SkeletonModule } from "primeng/skeleton";

@Component({
  selector: "app-events-table",
  imports: [SkeletonModule, EventTableRowComponent, PaginatorModule],
  templateUrl: "./events-table.component.html",
  styleUrl: "./events-table.component.scss",
})
export class EventsTableComponent {
  @Input() eventsPage: Page<EventInfoResponseBody> | null = null;
  @Input() showPagination = false;
  @Input() emptyMessage = "Você ainda não possui nenhum evento para exibir aqui!";
  @Input() rows = 10;

  @Output() pageChangeClick = new EventEmitter<PaginatorState>();

  first = 0;

  handlePageChange(page: PaginatorState) {
    this.pageChangeClick.emit(page);
  }
}
